import { render, staticRenderFns } from "./VerifyPasswordOTP.vue?vue&type=template&id=4dcbc116&scoped=true"
import script from "./VerifyPasswordOTP.vue?vue&type=script&lang=js"
export * from "./VerifyPasswordOTP.vue?vue&type=script&lang=js"
import style0 from "./VerifyPasswordOTP.vue?vue&type=style&index=0&id=4dcbc116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcbc116",
  null
  
)

export default component.exports